import { computed } from 'mobx';
import {
    CollectionApiFindAllCollectionsRequest,
    CollectionDto,
    CollectionItemDtoBrief,
} from 'src/generated-api-client';
import {
    bpmsResourcesManagerApi,
    collectionsApi,
} from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

export type CollectionsFilter =
    ListFilter<CollectionApiFindAllCollectionsRequest>;

export class CollectionsStoreClass extends BasicStore<
    CollectionItemDtoBrief,
    CollectionsFilter,
    unknown,
    unknown,
    CollectionDto
> {
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-24-collection-info.json';

    pager = new Pager();
    sorter = new Sorter();
    filterCriteria = new FilterCriteria<CollectionsFilter>();

    api: BasicStoreApi<
        CollectionItemDtoBrief,
        unknown,
        unknown,
        CollectionDto
    > = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                collectionsApi.findAllCollections(
                    {
                        ...this.pager,
                        ...this.sorter,
                        ...this.filterCriteria.filter,
                    },
                    options,
                ),
            );

            this.pager.setTotal(response.totalElements || 0);

            return response.content || [];
        },
        loadItem: (id, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                collectionsApi.getCollection({ id }, options),
            );
        },
        loadItemForm: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(
                    { formKey: this.itemDetailsFormKey },
                    options,
                ),
            );
        },
    };

    @computed get hasFilter() {
        return (
            Boolean(this.filterCriteria.filter.filterSearch) ||
            Boolean(this.filterCriteria.filter.filterStatuses) ||
            (Boolean(this.filterCriteria.filter.filterStartedAtFrom) &&
                Boolean(this.filterCriteria.filter.filterStartedAtTo))
        );
    }
}

export const CollectionsStore = new CollectionsStoreClass();
